import { Img } from '@/ui/components'
import { MuxBackgroundVideo } from '@mux/mux-background-video/react'
import { memo } from 'react'

const BackgroundVideo = ({
  isVideo,
  videoMuxCode
}: {
  isVideo?: boolean
  videoMuxCode?: string
}) => (
  <>
    {isVideo && videoMuxCode && (
      <MuxBackgroundVideo
        maxResolution="1080p"
        src={`https://stream.mux.com/${videoMuxCode}.m3u8`}
        className="absolute! inset-0!"
      >
        <Img
          data={{
            publicUrl: `https://image.mux.com/${videoMuxCode}/thumbnail.webp?time=0&width=720&height=405`
          }}
          naked={true}
          objectCover
          className="absolute inset-0 h-full w-full"
          fetchPriority="high"
          loading="eager"
          quality={60}
          priority
          alt="Mux Background Video"
        />
      </MuxBackgroundVideo>
    )}
  </>
)

BackgroundVideo.displayName = 'BackgroundVideo'

export default memo(BackgroundVideo)
